import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSwipeable } from 'react-swipeable';

import { toggleSnackBar } from 'apps/promo/actions/appAction';
import { useApp } from 'apps/promo/hooks/selectors';
import type { AppDispatch } from 'apps/promo/redux/store';

import { Container, InnerContent, SnackBarContainer } from './styles';

type SnackBarState = {
    isShowSnackBar?: boolean;
    messageForSnackBar?: React.ReactNode;
} | null;

export const SnackBar: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const timerId = useRef<number | null>(null);
    const snackBarState = useApp<SnackBarState>();
    const isShown = Boolean(snackBarState?.isShowSnackBar);
    const message = snackBarState?.messageForSnackBar;

    const close = useCallback(() => {
        if (timerId.current) {
            clearTimeout(timerId.current);
            timerId.current = null;
        }
        void dispatch(toggleSnackBar(false, ''));
    }, [dispatch]);

    useEffect(() => {
        if (isShown) {
            if (timerId.current) {
                return;
            }
            timerId.current = window.setTimeout(close, 2500);
        }
        return () => {
            if (timerId.current) {
                clearTimeout(timerId.current);
                timerId.current = null;
            }
        };
    }, [close, isShown]);

    const onSwipe = useSwipeable({
        onSwipedUp: () => close(),
        preventScrollOnSwipe: true,
        trackTouch: true,
    });

    if (!isShown) {
        return null;
    }

    return (
        <Container>
            <SnackBarContainer>
                <InnerContent {...onSwipe} data-testid="snack-content" onClick={close}>
                    {message}
                </InnerContent>
            </SnackBarContainer>
        </Container>
    );
};

export default SnackBar;
